<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxShow.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="spacer-banner"></span>
  <button mat-icon-button (click)="closeDialogCambiarFechaBdPresupuesto()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card class="card-grey">
  <mat-card-title class="card-title">CAMBIAR FECHAS CONSULTAS</mat-card-title>
  <mat-card-content>
    <div class="divmarco" style="padding: 0px !important;">
      <form [formGroup]="cambiarFechaBdForm" (ngSubmit)="onSubmit(cambiarFechaBdForm.value)">
        <hr>
        <div fxLayout="row" fxLayoutAlign="center center" class="divconten">
          <p style="font-weight: bold;">Fecha Data Actual: {{mesBaseDatos}} - {{anioBaseDatos}}</p>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column"
          fxLayout.xs="column" class="divconten">
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="input-width-275" floatLabel="always">
              <mat-label>Año</mat-label>
              <mat-select formControlName="nuevoAnio" (selectionChange)="loadMonths($event.value)" required
                placeholder="Seleccione una opción">
                <mat-option *ngFor="let item of listAnios" [value]="item.id">{{item.value}}</mat-option>
              </mat-select>
              <mat-icon matSuffix>calendar_month</mat-icon>
              <mat-error *ngIf="cambiarFechaBdForm.controls['nuevoAnio'].hasError('required')">Año es requerido.
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" appearance="outline" class="input-width-275" floatLabel="always">
              <mat-label>Mes</mat-label>
              <mat-select formControlName="nuevoMes" required placeholder="Seleccione una opción">
                <mat-option *ngFor="let item of listMeses" [value]="item.id">{{item.value}}</mat-option>
              </mat-select>
              <mat-icon matSuffix>calendar_month</mat-icon>
              <mat-error *ngIf="cambiarFechaBdForm.controls['nuevoMes'].hasError('required')">Mes es requerido.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="divconten">
          <p style="font-weight: bold;">(*) Estos campos son obligatorios.</p>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
          class="divconten">
          <div fxLayout="column">
            <button mat-raised-button (click)="closeDialogCambiarFechaBdPresupuesto()" color="warn" type="button"
              class="align-center-middle">
              <span class="text-icon-space">Regresar</span>
              <mat-icon>restart_alt</mat-icon>
            </button>
          </div>
          <div fxLayout="column">
            <button mat-raised-button color="primary" type="submit" class="align-center-middle">
              <span class="text-icon-space">Cambiar Fechas</span>
              <mat-icon>published_with_changes</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </mat-card-content>
</mat-card>